import React from "react";
import CommonList from "../../CommonList";

export default function CancelHistory() {
    return (
        <CommonList
            showHeader={false}
            reportType="dashboard_todays_cancelled_history"
        />
    );
}
